define(()=> {
    return function () {
        return {
            restrict: 'A',
            require: '^tab',
            link(scope, elm) {
                scope.$watch('headingElement', (heading)=> {
                    if (heading) {
                        elm.html('');
                        elm.append(heading);
                    }
                });
            }
        };
    };
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/widgets/tabs/directives/TabHeading.js